import styled from 'styled-components';

export const Container = styled('div')`
    color: ${(props) => (!props.withData ? props.theme.colors.disabledMeatballItem : props.theme.colors.cardSettingsTextColor)};
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    width: 100%;
    justify-content: space-between;

    .icon {
      fill: ${(props) => (!props.withData ? props.theme.colors.disabledMeatballItem : props.theme.cardAnnotationsMenu.iconColor)};
      :not(:first-child){
        margin-right: 13px;
      }
      :first-child{
        width: 100%;
        height: 100%;
      }
    }
    .icondown{
      fill: ${(props) => (!props.withData ? props.theme.colors.disabledMeatballItem : props.theme.cardAnnotationsMenu.iconDownColor)};
    }

`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  align-self: center;
  margin-right: 12px;
  margin-bottom: 2px;
`;

export const Label = styled.div`
  width: auto;
  display: flex;
  align-items: center;
`;

export const Action = styled.div`
  width: 40%;
`;
